import { Dropdown } from 'semantic-ui-react'
import * as React from 'react'
import useSWR from 'swr'
import { z } from 'zod'

import { classNames, validateResponse } from '../utils'
import { noteTemplateSchema } from '../types'
import { useApi } from '../store/mainContext'

interface Props {
  onChange(value: string): void
  disabled?: boolean
}

export default function NoteTemplatesDropdown(props: Props) {
  const { onChange, disabled } = props

  const api = useApi()

  const templates = useSWR(['note-templates'], () =>
    api
      .get('note-templates')
      .then(validateResponse(z.array(noteTemplateSchema))),
  )

  const noTemplates =
    !templates.isLoading && (templates.data || []).length === 0

  return (
    <Dropdown
      text={noTemplates ? 'No templates available' : 'Templates'}
      className={classNames('pr-3.5 text-sm', noTemplates && 'italic')}
      disabled={templates.isLoading || disabled || noTemplates}
      loading={templates.isLoading}
      selectOnBlur={false}
      pointing="top right"
      onOpen={() => templates.mutate()}
    >
      <Dropdown.Menu>
        {(templates.data || []).map((template) => (
          <Dropdown.Item
            className="!max-w-[260px]"
            onClick={() => onChange(template.body)}
            value={template.body}
            content={
              <>
                {template.name}
                {template.description && (
                  <div className="mt-1 line-clamp-2 whitespace-normal text-sm leading-none text-slate-500">
                    {template.description}
                  </div>
                )}
              </>
            }
            key={template._id}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
